export const addCouponReducer = (state, action) => {
    state.coupons[action.payload.id] = action.payload;
};

export const removeCouponReducer = (state, action) => {
    delete state.coupons[action.payload];
};

export const updateCouponReducer = (state, action) => {
    const updated = action.payload;
    if (state.coupons[updated.id]) {
        state.coupons[updated.id] = { ...state.coupons[updated.id], ...updated };
    }
};

export const setLoadingReducer = (state, action) => {
    state.loading = action.payload;
};

export const setErrorReducer = (state, action) => {
    state.error = action.payload;
};
